<template>
	<article class="grid md:grid-cols-2 lg:grid-cols-12 gap-1 lg:gap-6 px-6 py-4 items-center border-t border-grey -mt-px">
		<div class="col-span-1">
			<div class="uppercase flex items-center gap-2 text-md">
				<span class="text-sm">{{ item.event_start_date }}</span>
			</div>
		</div>
		<div class="md:col-span-2 lg:col-span-5 flex flex-col">
			<a :href="item.permalink" class="!underline !decoration-1 uppercase text-md leading-none font-bold text-black">{{ item.post_title }}</a>
			<span class="leading-tight uppercase" v-html="item.event_excerpt"></span>
		</div>
		<div class="col-span-1">
			<span class="uppercase">{{ item.event_start_time }}</span>
		</div>
		<div class="md:col-span-2">
			<span v-if="item.venue" class="tag !text-sm p-1 inline-flex gap-1 items-center" :class="venueClass">
				<MapPinIcon class="size-4" aria-hidden="true" />
				<span class="inline-flex font-bold uppercase">{{ item.venue.name }}</span>
			</span>
		</div>
		<div class="md:col-span-2 lg:col-span-3 lg:justify-self-end">
			<div class="flex flex-wrap gap-2 items-center md:justify-end">
				<span v-for="(tag, index) in item.event_availability_tags" :key="index" :class="`tag !text-sm tag--${ tag.key }`">{{ tag.label }}</span>
				<!-- <a :href="item.permalink" class="uppercase py-1 px-3 border border-grey rounded-3xl">Info</a> -->
				<a :href="item.event_buy_link" v-show="item.event_buy_link && !item.event_sold_out" class="uppercase py-1 px-3 border border-grey rounded-3xl hover:!bg-blue hover:!text-white hover:border-blue">{{ item.event_buy_text }}</a>
				<span v-show="isSoldOut" class="uppercase py-1 px-3 sold-out border border-red rounded-3xl">Sold out</span>
			</div>
		</div>
	</article>
</template>

<script setup>
import { computed } from "vue";
import { MapPinIcon } from "@heroicons/vue/20/solid";

const { item } = defineProps({
	item: {
		type: Object,
		required: true,
	},
});

const isSoldOut = computed(() => {
	return Boolean( Number(item.event_sold_out) );
})

const venueClass = computed(() => {
	return `mstag-${ item.venue.slug}`;
})

</script>
